import { Expose, Transform } from 'class-transformer';
import { PageTemplate } from '@icilalune/types';
import { DrupalIdentifier, DrupalNode } from '@nx-icilalune/drupal-types';

export class Page extends DrupalNode {
  public static readonly type = 'pages';

  @Transform(({ obj }) => {
    return obj?.relationships?.layout_template?.data?.meta?.name;
  })
  @Expose()
  template?: PageTemplate;

  @Transform(({ obj }) => {
    return obj?.relationships?.paragraphs?.data || undefined;
  })
  @Expose()
  paragraphs: DrupalIdentifier[] | undefined;

  @Transform(({ obj }) => {
    return obj?.relationships?.media?.data || undefined;
  })
  @Expose()
  media!: DrupalIdentifier[] | undefined;
}
